(function () {
    'ngInject';

    angular.module('app.shared.services').factory('CrosswordService', crosswordService);

    function crosswordService(blockUI, CrosswordAPIService, $window, $mdDialog, $timeout) {
        function generateCrossword($scope, canvas, textTyped, chipImageUrls) {
            const { bulkEdit, selectedObjectGroup, imageSelected } = $scope;
            const targetObjects = bulkEdit?.enabled
                ? selectedObjectGroup?._objects
                : imageSelected
                ? [imageSelected]
                : [];

            const blockUIMessage = 'Generating your crossword 📝✨🎨';
            blockUI.start(blockUIMessage);

            CrosswordAPIService.generateCrossword(textTyped, chipImageUrls)
                .then((blob) => {
                    const img = new Image();
                    const url = URL.createObjectURL(blob);
                    img.src = url;
                    img.onload = function () {
                        for (const targetObject of targetObjects) {
                            targetObject.setElement(img);
                            targetObject.testingUrl = img.src;
                        }
                        canvas.renderAll();
                    };
                    img.onerror = function (e) {
                        console.log(e);
                    };
                    //WTF, if I don't wrap the blockUI.stop() in a $scope.$apply it wont work :|
                    $scope.$apply(function () {
                        blockUI.stop();
                    });
                })
                .catch((error) => {
                    $window.rumReportError(error);
                    $timeout(() => $scope.$apply());
                    blockUI.stop();

                    $mdDialog.show(
                        $mdDialog
                            .alert()
                            .parent(document.body)
                            .clickOutsideToClose(true)
                            .title('We received an error the from Crossword generator:')
                            .textContent(error.message)
                            .ok('OK!')
                    );
                });
        }

        function getAllTextures() {
            return CrosswordAPIService.getTextures().catch((e) => {
                console.error(e);
                return [];
            });
        }

        function changeTexture(texturePath, crosswordSelected) {
            if (texturePath == 'null') {
                crosswordSelected.set('CrosswordConfig', null);
                return;
            }

            crosswordSelected.set('CrosswordConfig', {
                path: texturePath
            });
        }

        function getCurrentTexture(crosswordSelected) {
            return crosswordSelected?.CrosswordConfig?.path || null;
        }

        return {
            generateCrossword,
            getAllTextures,
            changeTexture,
            getCurrentTexture
        };
    }
})();
